import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgCheck = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M6.63 14q.594 0 .914-.5l6.236-9.906q.114-.178.167-.342A1 1 0 0 0 14 2.924q0-.404-.26-.664a.9.9 0 0 0-.666-.26.87.87 0 0 0-.467.116q-.186.11-.36.383l-5.643 9.182-2.892-3.763q-.312-.404-.773-.404A.91.91 0 0 0 2 8.458q0 .185.06.356.066.17.213.35l3.452 4.364q.372.472.906.472"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
